"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputGroupBehaviour = exports.InputGroupContext = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useInputBehaviour = _interopRequireDefault(require("./useInputBehaviour"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const defaultValue = {};

const InputGroupContext = /*#__PURE__*/_react.default.createContext(defaultValue);

exports.InputGroupContext = InputGroupContext;

const InputGroupBehaviour = ({
  children,
  blockGroupBehaviour
}) => {
  const contextValue = (0, _useInputBehaviour.default)(blockGroupBehaviour);
  return /*#__PURE__*/_react.default.createElement(InputGroupContext.Provider, {
    value: contextValue
  }, children);
};

exports.InputGroupBehaviour = InputGroupBehaviour;
InputGroupBehaviour.propTypes = {
  children: _propTypes.default.node,
  blockGroupBehaviour: _propTypes.default.bool
};